import React, { useEffect, useState } from "react";
import AppUpdateBanner from "./components/AppUpdateBanner";
import { Provider } from "react-redux";
import store from "../src/redux/store";
import EntryRouter from "./routers/entryRouter";
import { Toaster } from "react-hot-toast";
import { QueryClientProvider, QueryClient } from "react-query";
import "./index.css";
import { ThemeModeProvider } from "./theme/ThemeContext";
import {
  AblyProvider,
  ChannelProvider,
  useChannel,
  useConnectionStateListener,
} from "ably/react";
import * as Ably from "ably";
import { setupAxiosInterceptor } from "./config/tokenRefresh";
// import { configureAbly } from "@ably-labs/react-hooks";

function useTabLock() {
  const [isDuplicate, setIsDuplicate] = useState(false);

  useEffect(() => {
    if (!navigator.locks) return; // older browser: don't block
    let active = true;

    const hold = () =>
      new Promise((release) => {
        if (!active) return release();
        setIsDuplicate(false);
        window.addEventListener("pagehide", release, { once: true });
      });

    navigator.locks.request("stepout_active_tab", { ifAvailable: true }, (lock) => {
      if (lock) return hold();           // primary tab
      setIsDuplicate(true);              // duplicate: show notice…
      return navigator.locks.request("stepout_active_tab", hold); // …and wait to take over
    });

    return () => {
      active = false;
    };
  }, []);

  return isDuplicate;
}

const queryClient = new QueryClient();

const ablyClient = new Ably.Realtime({
  key: "_5T0zQ.XOp1Fg:li54clPnpFyM2nF1nzt2zJC_ioB2vXBdA_5M2xP_U_0",
});

function AppContent() {
  const isDuplicate = useTabLock();

  // Initialize axios interceptor on app load (must run before any early return
  // so the hook order stays consistent across renders).
  useEffect(() => {
    setupAxiosInterceptor();
  }, []);

  if (isDuplicate) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "var(--app-bg)",
          gap: 16,
        }}
      >
        <div
          style={{
            background: "var(--surface-1)",
            borderRadius: 12,
            padding: "40px 48px",
            boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
            textAlign: "center",
            maxWidth: 420,
          }}
        >
          <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
          <h2 style={{ fontFamily: "Roboto, sans-serif", margin: "0 0 8px", fontSize: 22 }}>
            App already open
          </h2>
          <p style={{ fontFamily: "Roboto, sans-serif", color: "var(--text-2)", margin: 0, fontSize: 15 }}>
            This app is already open in another browser tab. Please switch to that tab or close it before continuing here.
          </p>
        </div>
      </div>
    );
  }

  return (
    <AblyProvider client={ablyClient}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <ThemeModeProvider>
            <div>
              <Toaster />
            </div>
            <AppUpdateBanner />
            <EntryRouter />
          </ThemeModeProvider>
        </Provider>
      </QueryClientProvider>
    </AblyProvider>
  );
}

function App() {
  return <AppContent />;
}

export default App;